(function () {
  'use strict';

  angular
    .module('trainerWebApp.services')
    .factory('fileUpload', ['$q', '$resource', '$rootScope', fileUpload]);

  function fileUpload($q, $resource, $rootScope) {
    var initClient = function (config, securityPolicy) {
      var filestack = window['filestack'];
      if (!filestack) {
        return null;
      }

      return filestack.init(config.apiKey, { cname: config.cname, security: securityPolicy });
    };

    var pick = function (params) {
      params = params || {};
      params.customText = {
        'Select Files to Upload': 'Select File to Upload',
        'or Drag and Drop, Copy and Paste Files': 'or Drag and Drop, Copy and Paste File'
      };

      if (!params.maxSize) {
        params.maxSize = $rootScope.mfConfig.filestack.maxSize;
      }
      params.storeTo = $rootScope.mfConfig.filestack.storeTo;

      var client;
      return getSecurityPolicyUpload().then(function (securityPolicy) {
        if (!securityPolicy || !securityPolicy.policy || !securityPolicy.signature) {
          throw new Error('Cannot get security policy for file upload');
        }
        client = initClient($rootScope.mfConfig.filestack, securityPolicy);
        return $q(function (resolve, reject) {
          params.onUploadDone = onUploadDone(resolve, reject);
          try {
            client.picker(params).open();
          } catch (e) {
            reject(e);
          }
        });
      });
    };

    var onUploadDone = function (resolve, reject) {
      return function (result) {
        var outcome = { success: false };
        if (!result || !result.filesUploaded || !result.filesUploaded.length) {
          return resolve(outcome);
        }

        var tasks = result.filesUploaded.map(function (file) {
          return getSecurityPolicyRead(file.handle);
        });

        $q.all(tasks).then(function (policyRes) {
          policyRes.forEach(function (pres, index) {
            var url = new URL(result.filesUploaded[index].url);
            url.searchParams.append('policy', pres.policy);
            url.searchParams.append('signature', pres.signature);
            result.filesUploaded[index].url = url.toString();
          });

          outcome.success = true;
          outcome.data = {
            fileName: result.filesUploaded[0].filename,
            fileUrl: result.filesUploaded[0].url
          };

          resolve(outcome);
        }, function (err) {
          reject(err);
        });
      };
    };

    var getSecurityPolicyUpload = function () {
      var url = $rootScope.mfConfig.gaviotaApiBaseUrlSegment + '/filestorage/filestack/policy/upload';
      return $resource(url).get().$promise;
    };

    var getSecurityPolicyRead = function (fileHandle) {
      var url = $rootScope.mfConfig.gaviotaApiBaseUrlSegment + '/filestorage/filestack/policy/read/' + fileHandle;
      return $resource(url).get().$promise;
    };

    return {
      pick: pick,
      getSecurityPolicyUpload: getSecurityPolicyUpload,
      getSecurityPolicyRead: getSecurityPolicyRead
    };
  }
})();
